module.exports = __webpack_public_path__ + "media/images/sofa-3-c469a4fb0731745d1235ed12f28b468f.png";